import React from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

function Home() {
  return (
    <div>
      <div>
        <h2>Home</h2>
      </div>
      <div className="col d-flex justify-content-center pt-5">
        <Card style={{ width: '18rem' }}>
          <Card.Img
            variant="top"
            src="https://static1.colliderimages.com/wordpress/wp-content/uploads/2020/06/jurassic-park-samuel-l-jackson-slice.jpg"
            style={{ objectFit: 'cover' }}
          />
          <Card.Body>
            <Card.Title>Card Title</Card.Title>
            <Card.Text>
              Some quick example text to build on the card title and make up the
              bulk of the card's content.
            </Card.Text>
            <Button variant="primary">Hold on to your butts</Button>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}

export default Home;
